"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentDropzone = void 0;
/* eslint-disable react/jsx-props-no-spreading */
var core_ui_1 = require("@newfront-insurance/core-ui");
var next_notifications_1 = require("@newfront-insurance/next-notifications");
var react_1 = __importStar(require("react"));
var react_dropzone_1 = require("react-dropzone");
var use_archive_file_1 = require("../../hooks/use-archive-file");
var use_update_file_1 = require("../../hooks/use-update-file");
var use_upload_file_1 = require("../../hooks/use-upload-file");
var file_1 = require("../../lib/file");
var attachment_1 = require("../attachment");
var MAX_FILE_SIZE_MEGABYTES = 200;
function AttachmentDropzone(props) {
    var _this = this;
    var label = props.label, onChange = props.onChange, _a = props.initialAttachments, initialAttachments = _a === void 0 ? undefined : _a, _b = props.multiple, multiple = _b === void 0 ? true : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, _d = props.maxFileSizeMegabytes, maxFileSizeMegabytes = _d === void 0 ? MAX_FILE_SIZE_MEGABYTES : _d, refs = props.refs, documentTypes = props.documentTypes, defaultDocumentType = props.defaultDocumentType;
    var notifications = (0, next_notifications_1.useNotifications)();
    var uploadFile = (0, use_upload_file_1.useUploadFile)()[0];
    var updateFile = (0, use_update_file_1.useUpdateFile)()[0];
    var archiveFile = (0, use_archive_file_1.useArchiveFile)()[0];
    var _e = (0, react_1.useState)(initialAttachments || []), attachments = _e[0], setAttachments = _e[1];
    // we want to indicate that attachmeents
    var _f = (0, react_1.useState)([]), skeletonCount = _f[0], setSkeletonCount = _f[1];
    // we need a way to indicate if we've only got initial attachments.
    // Nothing has been added or removed.
    // Therefore we know we dont want to fire the onChange handler in useEffect
    var _g = (0, react_1.useState)(!!initialAttachments), hasCleanInitialAttachments = _g[0], setHasCleanInitialAttachments = _g[1];
    // when attachments are being uploaded or updated, we can indicate
    // that we are performing an API request, preventing the parent form
    // for being 'completed' until these actions have finished.
    var _h = (0, react_1.useState)(false), performingApiRequest = _h[0], setPerformingApiRequest = _h[1];
    var notifyExceedsMaxFileSize = function (_a) {
        var name = _a.name;
        notifications.addById('attachment-dropzone', {
            title: "".concat(name, " size exceeds ").concat(maxFileSizeMegabytes, "MB limit"),
            type: 'error',
        });
    };
    var handleUpload = function (droppedAttachments) { return __awaiter(_this, void 0, void 0, function () {
        var uploadAttachments, uploadedFiles, filtered;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // notify of any filed exceeding 'exceedsFileMaxSize'
                    droppedAttachments.map(function (file) {
                        if ((0, file_1.exceedsFileMaxSize)(file.size, maxFileSizeMegabytes)) {
                            notifyExceedsMaxFileSize(file);
                        }
                        return false;
                    });
                    uploadAttachments = function () { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            return [2 /*return*/, Promise.all(droppedAttachments
                                    .filter(function (file) { return !(0, file_1.exceedsFileMaxSize)(file.size, maxFileSizeMegabytes); })
                                    .map(function (file) { return __awaiter(_this, void 0, void 0, function () {
                                    var uploadedFile;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, uploadFile(file, refs, defaultDocumentType)];
                                            case 1:
                                                uploadedFile = _a.sent();
                                                return [2 /*return*/, uploadedFile];
                                        }
                                    });
                                }); }))];
                        });
                    }); };
                    return [4 /*yield*/, uploadAttachments()];
                case 1:
                    uploadedFiles = _a.sent();
                    filtered = uploadedFiles.filter(function (val) { return !!val; });
                    if (filtered)
                        setAttachments(__spreadArray(__spreadArray([], attachments, true), filtered, true));
                    setPerformingApiRequest(false);
                    setSkeletonCount([]);
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * onDrop
     * Store dropped files.
     */
    var onDrop = function (droppedAttachments) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPerformingApiRequest(true);
                    // populate an array of indexes for the number of droppedAttachments.
                    // we use these indexs as keys for the <AttachmentSkeleton key={} />
                    setSkeletonCount(Array.from({ length: droppedAttachments.length }, function (_, i) { return i + 1; }));
                    if (hasCleanInitialAttachments)
                        setHasCleanInitialAttachments(false);
                    if (!!multiple) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleUpload([droppedAttachments[0]])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
                case 2: return [4 /*yield*/, handleUpload(droppedAttachments)];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * updateAttachment
     * take a value and a property to update on the attachment, with such value
     */
    var updateAttachment = (0, core_ui_1.useDebouncedCallback)((0, react_1.useCallback)(function (value, property, attachment, index) {
        var _a;
        // NOTE that the 'filename' value will not include a file extension
        // this will be appended
        var updatedValue = property === 'filename' ? "".concat(value, ".").concat(attachment.fileExtension) : value;
        // create the new attachment object
        var newAttachment = __assign(__assign({}, attachment), (_a = {}, _a[property] = updatedValue, _a));
        // save the updated attachment object to state immediately,
        // before attempting to update via file-api
        var newAttachments = __spreadArray([], attachments, true);
        newAttachments.splice(index, 1, newAttachment);
        setAttachments(newAttachments);
        if (hasCleanInitialAttachments)
            setHasCleanInitialAttachments(false);
        // send updated details to file-api
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        updateFile({
            id: newAttachment.id,
            filename: newAttachment.filename,
            category: newAttachment.category,
            meta: { summary: newAttachment.summary },
        });
    }, [attachments, hasCleanInitialAttachments, updateFile]), 1000);
    /**
     * removeAttachment
     * Remove any attachment with a matching id
     */
    var removeAttachment = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var found, remainingAttachments;
        return __generator(this, function (_a) {
            setPerformingApiRequest(true);
            found = attachments.find(function (attm) { return attm.id === id; });
            remainingAttachments = found && attachments.filter(function (attm) { return attm.id !== found.id; });
            // set the remaining attachments to state immediately,
            // before attempting to archive via file-api
            setAttachments([]);
            setAttachments(remainingAttachments || []);
            setPerformingApiRequest(false);
            if (hasCleanInitialAttachments)
                setHasCleanInitialAttachments(false);
            // if we have an attachment to remove, send the id to file-api
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            if (found)
                archiveFile(found.id);
            return [2 /*return*/];
        });
    }); };
    /**
     * We can disable the parent form when an API request is being performed.
     * This just indicates 'something is happening'
     * Only do this when something has changed
     */
    (0, react_1.useEffect)(function () {
        if (!hasCleanInitialAttachments && onChange)
            onChange(attachments, performingApiRequest);
        // eslint-disable-next-line
    }, [attachments, performingApiRequest]);
    var _j = (0, react_dropzone_1.useDropzone)({ onDrop: onDrop }), getRootProps = _j.getRootProps, getInputProps = _j.getInputProps, isDragActive = _j.isDragActive, isFileDialogActive = _j.isFileDialogActive;
    return (react_1.default.createElement("div", { className: "attachment-dropzone" },
        attachments.map(function (attachment, i) { return (react_1.default.createElement(attachment_1.Attachment, { key: attachment.id, attachment: attachment, onRemove: function () { return removeAttachment(attachment.id); }, 
            /* eslint-disable @typescript-eslint/prefer-optional-chain */
            onNameChange: function (filename) { return updateAttachment && updateAttachment(filename, 'filename', attachment, i); }, onDocTypeChange: function (category) { return updateAttachment && updateAttachment(category, 'category', attachment, i); }, onSummaryChange: function (summary) { return updateAttachment && updateAttachment(summary, 'summary', attachment, i); }, documentTypes: documentTypes, defaultDocumentType: defaultDocumentType })); }),
        performingApiRequest && skeletonCount.length > 0 && (react_1.default.createElement(core_ui_1.Padding, { top: attachments.length ? 24 : 0 }, skeletonCount.map(function (count) { return (react_1.default.createElement(core_ui_1.AttachmentSkeleton, { key: count })); }))),
        react_1.default.createElement("div", __assign({}, getRootProps(), { style: { outline: 'none', paddingTop: attachments.length || skeletonCount.length ? '12px' : '0' } }),
            !performingApiRequest && react_1.default.createElement("input", __assign({}, getInputProps())),
            react_1.default.createElement(core_ui_1.Dropzone, { label: label, disabled: performingApiRequest || disabled || isDragActive || isFileDialogActive }))));
}
exports.AttachmentDropzone = AttachmentDropzone;
